module.exports = __webpack_public_path__ + "img/DownloadPageMonitor 1.1f20a819.svg";